<div class="panel" 
  [ngClass]="{
    'panel--open': open, 
    'panel--fixed': !canToggle, 
    'panel--compact': isCompact 
  }">
  <div class="panel__header" (click)="handleClickHeader()" *ngIf="label">
    <div class="panel__label text-12">{{ label }}</div>

    <div class="panel__actions" appEventFence>
      <ng-content select="[panel-actions]"></ng-content>
    </div>

    <div class="panel__toggle rotate--animate" [class.rotate-90]="open" [class.rotate-0]="!open" *ngIf="canToggle">
      <app-icon icon="angle-right"></app-icon>
    </div>
  </div>

  <div class="panel__body">
    <ng-content></ng-content>
  </div>
</div>